export default [
    // {
    //     name: "room_model",
    //     type: "gltfModel",
    //     path: '/models/my-room.glb'
    // },
    {
        name: "room_model_min",
        type: "dracoModel",
        path: "/models/my-room-min.glb"
    },
    {
        name: "table_map",
        type: "texture",
        path: "/textures/table_baked_diff_2k.jpg"
    },
    {
        name: "wall_map",
        type: "texture",
        path: "/textures/baked_wall.webp"

    },
    {
        name: 'window_map',
        type: 'texture',
        path: '/textures/baked_window_diff.jpg'
    }
]